import { jsx } from "react/jsx-runtime";
import { useMediaQuery } from "@mui/material";
import {
  createContext,
  useContext,
  useMemo,
  useState
} from "react";
const colorSchemeContext = createContext({
  mode: "light",
  setMode: () => {
  },
  toggleColorScheme: () => {
  }
});
function ColorSchemeProvider(props) {
  const { enableUserPreferredColorScheme, children } = props;
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const [mode, setMode] = useState(
    () => enableUserPreferredColorScheme && prefersDarkMode ? "dark" : "light"
  );
  const contextValue = useMemo(() => {
    function toggleColorScheme() {
      setMode((p) => p === "dark" ? "light" : "dark");
    }
    return {
      mode,
      toggleColorScheme,
      setMode
    };
  }, [mode]);
  return /* @__PURE__ */ jsx(colorSchemeContext.Provider, { value: contextValue, children });
}
function useColorScheme() {
  return useContext(colorSchemeContext);
}
export {
  ColorSchemeProvider,
  useColorScheme
};
//# sourceMappingURL=ColorSchemeProvider.js.map
